<p-dialog [header]="headerLabel" [(visible)]="visible" (onHide)="handleCancel()" [modal]="true" [style]="{ width: '60vw' }">
  <div class="card">
    <p-table [value]="feesList" dataKey="id" selectionMode="single" [(selection)]="tempSelectedFee" [trackBy]="trackByFee">
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Amount</th>
            <th *ngIf="sectionType === DialogTypeFeeOrDiscount.DISCOUNT">Start Date</th>
            <th *ngIf="sectionType === DialogTypeFeeOrDiscount.DISCOUNT">End Date</th>
            <th>Taxable</th>
          </tr>
        </ng-template>
      
        <ng-template pTemplate="body" let-product>
          <tr [pSelectableRow]="product">
            <td>{{ getDisplayName(product) }}</td>
            <td>{{ getDisplayType(product) }}</td>
            <td>
              <ng-container [ngSwitch]="true">
                <span *ngSwitchCase="isAmountType(product)">
                  {{ baseCurrency?.symbol }}{{ product.discountValue }}
                </span>
                <span *ngSwitchCase="isPercentageType(product)">
                  {{ product.discountValue }}{{ getPercentageSymbol(product) }}
                </span>
              </ng-container>
            </td>
            <td *ngIf="sectionType === DialogTypeFeeOrDiscount.DISCOUNT">{{product?.validFromDate ? (product?.validFromDate | date: 'MM/dd/yyyy') : ''}}</td>
            <td *ngIf="sectionType === DialogTypeFeeOrDiscount.DISCOUNT">{{product?.validToDate ? (product?.validToDate | date: 'MM/dd/yyyy') : ''}}</td>
            <td>{{ product.isTaxable ? 'Yes' : 'No' }}</td>
          </tr>
        </ng-template>
      
        <ng-template pTemplate="body" *ngIf="!feesList?.length">
          <tr>
            <td [attr.colspan]="sectionType === DialogTypeFeeOrDiscount.DISCOUNT ? 6 : 4" style="text-align: center; font-style: italic;">
              No data available.
            </td>
          </tr>
        </ng-template>
    </p-table>
  </div>

  <ng-template pTemplate="footer">
    <p-button (click)="handleCancel()" label="Cancel" styleClass="p-button-secondary"></p-button>
    <p-button label="Apply" [disabled]="dialogType === 'VIEW'" (click)="handleApply()"></p-button>
  </ng-template>
</p-dialog>
